<template>
  <section class="aboutUs section" id="about">
    <div class="container">
      <div class="row">
        <div class="col">
          <h1>
            <span class="firstTitle">{{ $t('about') }}</span>
            <span class="secondTitle">{{ $t('us') }}</span>
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>{{ $t('about_description_1') }} <br/> {{ $t('about_description_2') }}</p>
        </div>
      </div>
        <MembersPortfolio/>
    </div>
  </section>
</template>

<script>
import MembersPortfolio from './MembersPortfolio.vue'
export default {
  name: "AboutUs",
  components: {
    MembersPortfolio
  },
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
